export default __webpack_public_path__ + "static/media/test_image_2.47690cfe.png";